import { roundDollars } from './roundDollars'

export default function debtRound(str: string) {
  return str.replace(/\$([\d,]+(?:\.\d+)?)/g, (_, num) => {
    let n = parseFloat(num.replace(/,/g, ''))
    n = roundDollars(n, n >= 9500 ? 1000 : 100)
    return `$${n.toLocaleString()}`
  })
}
